// Route protégée : redirige vers /login si non authentifié,
// vers /onboarding si l'entreprise n'a pas encore été créée.
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { roleEffectif } from "@/lib/roles";
import { Loader2 } from "lucide-react";

function Chargement() {
  return (
    <div
      data-testid="ecran-chargement"
      className="min-h-screen flex items-center justify-center bg-[#E8F4F4]"
    >
      <div className="flex flex-col items-center gap-3 text-[#1D3D3D]">
        <Loader2 className="h-8 w-8 animate-spin" />
        <p className="text-sm font-medium">Chargement…</p>
      </div>
    </div>
  );
}

export function ProtectedRoute({ children, exigerEntreprise = true, exigerAcces = true, exigerAbonnement = true }) {
  const { user, company, companyChargee, abonnement, estAdmin } = useAuth();
  const location = useLocation();

  if (user === null) return <Chargement />;
  if (user === false) return <Navigate to="/login" replace state={{ from: location }} />;

  if (exigerEntreprise) {
    if (!companyChargee) return <Chargement />;
    if (!company) return <Navigate to="/onboarding" replace />;
    // Le questionnaire et le choix de formule ne concernent que le gérant et
    // l'administrateur. Les profils invités accèdent directement après activation.
    const role = roleEffectif(user);
    const estGestionnaire = role === "gerant" || role === "administrateur";
    if (exigerAcces && estGestionnaire && !company.acces_saisie) return <Navigate to="/quiz" replace />;
    if (exigerAbonnement && !estAdmin && estGestionnaire && !abonnement) return <Navigate to="/formules" replace />;
  }

  return children;
}

export default ProtectedRoute;
